import { ChipOwnProps } from "@mui/material"

export const durationArray = [
  { title: "30 minutes", value: "30" },
  { title: "60 minutes", value: "60" },
  { title: "90 minutes", value: "90" },
  { title: "120 minutes", value: "120" },
  { title: "150 minutes", value: "150" },
  { title: "180 minutes", value: "180" },
]

export enum DaypassType {
  DAYPASS = "daypass",
  BULKDAYPASS = "bulk_daypass",
}

export enum VerificationLogStatus {
  VALID = "valid",
  INVALID = "invalid",
  VERIFY = "verify",
  ACCEPT = "accept",
  REJECT = "reject",
  FAILED = "failed",
}

export enum DaypassBookingStatus {
  AVAILABLE = "available",
  USED = "used",
  EXPIRED = "expired",
}

export enum BookingRefType {
  NONE = "none",
  ANDROID = "android-app",
  IOS = "ios-app",
  SYSTEM = "system",
  WEB = "web",
}

export enum PaymentStatus {
  PENDING = "pending",
  PAID = "paid",
  FAILED = "failed",
  CANCELLED = "cancelled",
  REFUNDED = "refunded",
}

export enum UserStatus {
  CREATED = "created",
  INVITED = "invited",
  ACTIVE = "active",
  INACTIVE = "inactive",
  SUSPENDED = "suspended",
  DELETED = "deleted",
  PARTIALLY_REGISTERED = "partially_registered",
}

export enum MeetingRoomType {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
}

export enum VerificationLogType {
  ENTRY = "entry",
  EXIT = "exit",
  RE_ENTRY = "re-entry",
}

export enum VerificationLogPurpose {
  MEETING_ROOM = "meeting_room",
  DAY_PASS = "day_pass",
  OTHER = "other",
}

export enum MeetingRoomBookingStatus {
  ACTIVE = "active",
  EXPIRED = "expired",
  INACTIVE = "expired",
}

export enum UserRole {
  ADMIN = "admin",
  AUDITOR = "auditor",
  ACCOUNT = "account",
  ACCOUNT_ADMIN = "account_admin",
  ALTS_ACCOUNT_ADMIN = "alts_account_admin",
  ALTS_SALES = "alts_sales",
}

export enum MarkedStatus {
  MARKED = "True",
  UNMARKED = "False",
  PENDING = "Pending",
}

export enum TransactionType {
  INFLOW = "Inflow",
  OUTFLOW = "Outflow",
}

export const transactionTypeLabels = {
  [TransactionType.INFLOW]: "Inflow",
  [TransactionType.OUTFLOW]: "Outflow",
}

export enum EntityType {
  BANK_TRANSFER = "bank_transfer",
  PAYMENT = "payment",
  SETTLEMENT = "settlement",
}

export const entityTypeLabels = {
  bank_transfer: "Bank Transfer",
  payment: "Payment",
  settlement: "Settlement",
}

export const operators: {
  option: string
  value: string
}[] = [
  {
    option: "",
    value: "",
  },
  {
    option: "Equal ( = )",
    value: "eq",
  },
  {
    option: "Greater than Equal ( >= )",
    value: "gte",
  },
  {
    option: "Less than Equal ( <= )",
    value: "lte",
  },
  {
    option: "Less Than ( < )",
    value: "lt",
  },
  {
    option: "Greater Than ( > )",
    value: "gt",
  },
]

export const allowedOnlyTrasactionsRoles: string[] = [
  UserRole.ACCOUNT,
  UserRole.ACCOUNT_ADMIN,
  UserRole.ALTS_ACCOUNT_ADMIN,
  UserRole.ALTS_SALES,
]

export const allowedOnlyBankAccountsRoles: string[] = [
  UserRole.ADMIN,
  UserRole.ACCOUNT_ADMIN,
]
export const allowedCategoryRoles: string[] = [
  UserRole.ADMIN,
  UserRole.ACCOUNT_ADMIN,
  UserRole.ALTS_ACCOUNT_ADMIN,
]
export const allowedCategorisationRoles: string[] = [
  UserRole.ACCOUNT,
  UserRole.ACCOUNT_ADMIN,
  UserRole.ALTS_ACCOUNT_ADMIN,
  UserRole.ALTS_SALES,
]

export const PaymentStatusColors: Record<PaymentStatus, ChipOwnProps["color"]> =
  {
    [PaymentStatus.PENDING]: "primary",
    [PaymentStatus.PAID]: "success",
    [PaymentStatus.FAILED]: "error",
    [PaymentStatus.CANCELLED]: "warning",
    [PaymentStatus.REFUNDED]: "info",
  }

export enum DateFilterValues {
  TODAY = "today",
  TOMORROW = "tomorrow",
  YESTERDAY = "yesterday",
  WEEK = "week",
  MONTH = "month",
  LAST_MONTH = "last month",
  QUARTER = "quarter",
  LAST_QUARTER = "last quarter",
  SEVEN_DAYS = "7 days",
  THRITY_DAYS = "30 days",
  LAST_NINTY_DAYS = "last 90 days",
  CUSTOM = "custom",
}

export const DateFilterLabels = {
  [DateFilterValues.TODAY]: "Today",
  [DateFilterValues.TOMORROW]: "Tomorrow",
  [DateFilterValues.YESTERDAY]: "Yesterday",
  [DateFilterValues.WEEK]: "This Week",
  [DateFilterValues.MONTH]: "This Month",
  [DateFilterValues.LAST_MONTH]: "Last Month",
  [DateFilterValues.QUARTER]: "This Quarter",
  [DateFilterValues.LAST_QUARTER]: "Last Quarter",
  [DateFilterValues.SEVEN_DAYS]: "Last 7 days",
  [DateFilterValues.THRITY_DAYS]: "Last 30 days",
  [DateFilterValues.LAST_NINTY_DAYS]: "Last 90 days",
  [DateFilterValues.CUSTOM]: "Custom",
}

export enum InvoiceStatus {
  GENERATED = "generated",
  REQUESTED = "requested",
  NOT_REQUESTED = "not_requested",
}

export enum BusinessEntity {
  TUSKER = "tusker",
  ZENITH = "zenith",
}

export const gstStateCodes = {
  "01": "Jammu & Kashmir",
  "02": "Himachal Pradesh",
  "03": "Punjab",
  "04": "Chandigarh",
  "05": "Uttarakhand",
  "06": "Haryana",
  "07": "Delhi",
  "08": "Rajasthan",
  "09": "Uttar Pradesh",
  "10": "Bihar",
  "11": "Sikkim",
  "12": "Arunachal Pradesh",
  "13": "Nagaland",
  "14": "Manipur",
  "15": "Mizoram",
  "16": "Tripura",
  "17": "Meghalaya",
  "18": "Assam",
  "19": "West Bengal",
  "20": "Jharkhand",
  "21": "Odisha",
  "22": "Chhattisgarh",
  "23": "Madhya Pradesh",
  "24": "Gujarat",
  "25": "Daman & Diu",
  "26": "Dadra & Nagar Haveli",
  "27": "Maharashtra",
  "28": "Andhra Pradesh (Old)",
  "29": "Karnataka",
  "30": "Goa",
  "31": "Lakshadweep",
  "32": "Kerala",
  "33": "Tamil Nadu",
  "34": "Puducherry",
  "35": "Andaman & Nicobar Islands",
  "36": "Telangana",
  "37": "Andhra Pradesh (Newly Added)",
  "38": "Ladakh (Newly Added)",
  "97": "Others Territory",
  "99": "Center Jurisdiction",
}

export enum AuditLogType {
  ENTRY = "entry",
  REENTRY = "re-entry",
}

export const CenterTypes = [
  { title: "Platinum", value: "platinum" },
  { title: "Platinum Plus", value: "platinum_plus" },
  { title: "Premium", value: "premium" },
  { title: "Workspace", value: "workspace" },
  { title: "Business Lounge", value: "business_lounge" },
]

export enum UploadStatus {
  SUCCESS = "success",
  PROCESSING = "processing",
  FAILED = "failed",
  RECONCILED = "reconciled",
}

export enum processScheduleStatus {
  PENDING = "pending",
  IN_PROGRESS = "in_progress",
}

export enum CustomerStatus {
  ACTIVE = "active",
  DELETED = "deleted",
  INACTIVE = "inactive",
}

export enum CustomerInvoiceStatus {
  SENT = "sent",
  DRAFT = "draft",
  OVERDUE = "overdue",
  PAID = "paid",
  VOID = "void",
  UNPAID = "unpaid",
  PARTIALLY_PAID = "partially_paid",
  VIEWED = "viewed",
  EXPIRED = "expired",
  DELETED = "deleted",
}

export const INVOICE_STATUS_CONFIG = [
  {
    status: CustomerInvoiceStatus.PAID,
    title: "Paid",
    color: "#16A34A",
  },
  {
    status: CustomerInvoiceStatus.PARTIALLY_PAID,
    title: "Partially Paid",
    color: "#22C55E",
  },
  {
    status: CustomerInvoiceStatus.SENT,
    title: "Sent",
    color: "#527bd3",
  },
  {
    status: CustomerInvoiceStatus.VIEWED,
    title: "Viewed",
    color: "#3B82F6",
  },
  {
    status: CustomerInvoiceStatus.OVERDUE,
    title: "Overdue",
    color: "#F59E0B",
  },
  {
    status: CustomerInvoiceStatus.DRAFT,
    title: "Draft",
    color: "#9CA3AF",
  },
  {
    status: CustomerInvoiceStatus.VOID,
    title: "Void",
    color: "#6B7280",
  },
  {
    status: CustomerInvoiceStatus.UNPAID,
    title: "Unpaid",
    color: "#EF4444",
  },
  {
    status: CustomerInvoiceStatus.EXPIRED,
    title: "Expired",
    color: "#DC2626",
  },
  {
    status: CustomerInvoiceStatus.DELETED,
    title: "Deleted",
    color: "#7F1D1D",
  },
]
